import { IAppState } from 'src/store/types';

export const getInfrastructureFilters = (state: IAppState) => state.infrastructure;
